import { ProductionTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { SaleOrder } from "../sale-order.entitiy";

@Entity('so_production')
export class SoProduction {
    @PrimaryGeneratedColumn("increment", { name: 'so_production_id' })
    soProductionId: number;

    @Column("varchar",{
        nullable:false,
        name:"lot_no"
        })
        lotNumber:string;

    @Column({
        type:"enum",
        enum: ProductionTypeEnum,
        nullable: true,
        name: "type"
      })
      type: ProductionTypeEnum;

    @Column("int", {
        nullable: false,
        name: "sale_order_id"
    })
    saleOrderId: number;

    @Column("int", {
        nullable: false,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;

    @Column({
        type:"decimal",precision:10,scale:3,
        nullable: true,
        name: "input_quantity",
        default:0
    })
    inputQuantity: number;

    @Column({
        type:"decimal",precision:10,scale:3,
        nullable: true,
        name: "output_quantity",
        default:0
    })
    outputQuantity: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true, 
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}